<template>
	<b-modal
		id="topicConfg"
		centered
		hide-footer
		hide-header
		no-close-on-backdrop
		size="lg"
		v-model="context.topicModal"
	>
		<div class="modalheading">
			<span v-if="topicDetails.active == true">Edit Topic</span>
			<span v-else>Activate Topic</span>
		</div>

		<div @click="closetopicmodal()" class="xMarkCancel">
			<img src="../../../assets/xmark.svg" alt="" />
		</div>
		<hr />
		<b-row>
			<b-col>
				<div class="topDiv mt-3">
					<label class="fieldsetStyle"
						>Topic Name &nbsp;<span class="asterik">*</span></label
					>
					<b-form-input
						v-on:keyup.enter="gotoedit()"
						:class="{ error: context.$v.clone.name.$error }"
						v-model.trim="context.$v.clone.name.$model"
						id="input-1"
						autofocus
						type="text"
					></b-form-input>
					<div
						style="position: absolute; top: 5px; right: 12px; background-color: #fff;"
						v-if="
							context.$v.clone.name.$dirty && !context.$v.clone.name.required
						"
						v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						variant="primary"
					>
						<img src="../../../assets/deletepopupicon.svg" alt="" />
					</div>

					<div
						style="position: absolute; top: 5px; right: 12px; background-color: #fff;"
						v-if="
							!context.$v.clone.name.maxLength && context.$v.clone.name.required
						"
						v-b-popover.hover.top.v-danger="{
							content: 'Should not exceed 120 characters',
						}"
						variant="primary"
					>
						<img src="../../../assets/deletepopupicon.svg" alt="" />
					</div>
				</div>
			</b-col>
		</b-row>

		<div>
			<div class="topDiv mt-3">
				<label class="fieldsetStyle">Description&nbsp;</label>
				<b-form-textarea
					:class="{ error: context.$v.clone.description.$error }"
					v-model.trim="context.$v.clone.description.$model"
					id="textarea-large"
					class="inputField"
					size="lg"
					rows="3"
					max-rows="6"
				></b-form-textarea>
				<div
					style="position: absolute; top: 5px; right: 12px"
					v-if="!context.$v.clone.description.maxLength"
					v-b-popover.hover.top.v-danger="{
						content: 'Should not exceed 250 characters',
					}"
					variant="primary"
				>
					<img src="../../../assets/deletepopupicon.svg" alt="" />
				</div>
			</div>
		</div>
		<div class="d-flex justify-content-end mt-3">
			<b-button class="addbtn">
				<span v-if="topicDetails.active == true" @click="editTopic()">
					Update</span
				>

				<span v-else-if="clone.inActiveTestCount == 0" @click="editTopicModal()"
					>Activate</span
				>
				<span v-else @click="getActivateTests()">Activate</span>
			</b-button>
		</div>
	</b-modal>
</template>

<script>
import { editTopic, editTopicModal, getActivateTests } from "../asynchronous";
export default {
	name: "EditTopicModal",
	data() {
		return {};
	},
	props: {
		topicDetails: Object,
		nameEdit: String,
		clone: Object,
		context: Object,
	},
	methods: {
		gotoedit() {
			if (this.clone.active) {
				editTopic(this.context);
			} else if (this.clone.inActiveTestCount == 0) {
				editTopicModal(this.context);
			} else {
				getActivateTests(this.context);
			}
		},
		closetopicmodal() {
			this.$bvModal.hide("topicConfg");
			this.context.$emit(
				"card-option",
				this.context.topicDetails.topicID,
				false
			);
			this.context.selTopic = "";
		},

		async editTopic() {
			await editTopic(this.context);
		},
		async editTopicModal() {
			await editTopicModal(this.context);
		},
		async getActivateTests() {
			await getActivateTests(this.context);
		},
	},
};
</script>
